import {GET_LIST} from 'react-admin';

/**
 * Decorator for campaigns related requests
 *
 * @param requestHandler
 * @returns {function(...[*]=)}
 */
export const campaignsDecorator = requestHandler => (type, resource, params) => {
    if (resource !== 'campaigns') {
        return requestHandler(type, resource, params);
    }

    if (type === GET_LIST) {
        params = applyDefaultArchiveFilter(params);
    }

    return requestHandler(type, resource, params);
};

/**
 * Make sure the inArchive filter is always set
 *
 * @param params
 * @returns {*}
 */
const applyDefaultArchiveFilter = (params) => {
    const {filter} = params;

    if (!filter.hasOwnProperty('inArchive')) {
        params.filter['inArchive'] = false;
    }

    return params;
};